// State-less request functions go in here.
// Stuff that requires state management (such as user.js) have their own script.
import Store from '../store'
import User from './user'

let request = require('superagent')
let _ = require('highland')

// HTTP GET - expects a table from a UMM Dataset
export function getUmmDSTable(endpoint, query, table) {
  let rtn = _()
  request
  .get(endpoint)
  .query(query)
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .end((err, res) => {
    if (err || !res.ok) {
      if (res.statusCode == 422) {
        console.log('Received a 422')
        rtn.end()
      } else {
        console.log('Received an error')
        console.log(JSON.stringify(res))
        rtn.write(err)
      }
    } else {
      if (res.body.uMMds[table]) {
          res.body.uMMds[table].forEach((item) => {
          rtn.write(item)
        })
      }
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

export function getWorkOrders() {
  return getUmmDSTable('/umm/ummwolist', { useSystemCode: User.getSystemCode() }, 'uMMWorkOrder')
}

export function getSolutionCodes() {
  return getUmmDSTable('/umm/ummsolution', { useSystemCode: User.getSystemCode() }, 'uMMSolution')
}

export function getWorkOrder(id) {
  return getUmmDSTable('/umm/ummworkorder', { useSystemCode: User.getSystemCode(), woNumber: id }, 'uMMWorkOrder')
}

export function getLabor(id) {
  return getUmmDSTable('/umm/ummwolabor', { useSystemCode: User.getSystemCode(), woNumber: id }, 'uMMWOLabor')
}

export function getMaterial(id) {
  return getUmmDSTable('/umm/ummwomaterial', { useSystemCode: User.getSystemCode(), woNumber: id }, 'uMMWOMaterial')
}

export function getEquipment(id) {
  return getUmmDSTable('/umm/ummwoequipment', { useSystemCode: User.getSystemCode(), woNumber: id }, 'uMMWOEquipment')
}

export function getPhoto(id) {
  return getUmmDSTable('/umm/ummwostoredobject', { useSystemCode: User.getSystemCode(), woNumber: id }, 'uMMWOStoredObject')
}

export function getNotes(id) {
  return getUmmDSTable('/umm/ummwonotes', { useSystemCode: User.getSystemCode(), woNumber: id }, 'uMMWONotes')
}

export function getEmployeeList() {
  return getUmmDSTable('/umm/ummemployee', { useSystemCode: User.getSystemCode()}, 'uMMEmployee')
}

export function getMaterialList() {
  return getUmmDSTable('/umm/ummmaterial', { useSystemCode: User.getSystemCode()}, 'uMMMaterial')
}

export function getEquipmentList() {
  return getUmmDSTable('/umm/ummequipment', { useSystemCode: User.getSystemCode()}, 'uMMEquipment')
}

export function getRandomKey() {
  return getUmmDSTable('/umm/ummfilename', { useSystemCode: User.getSystemCode()}, 'uMMFileName')
}

function postUmmDSTableLabor(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    ummds: {
      'uMMWOLabor': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .post(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    console.log('Getting data from the map!')
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function postUmmDSTableEquipment(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOEquipment': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .post(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber, dumpsodalog:'y' })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function postUmmDSTableMaterial(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOMaterial': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .post(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber, dumpsodalog:'y' })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function postUmmDSTablePhoto(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOStoredObject': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .post(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber, dumpsodalog:'y' })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function postUmmDSTableNotes(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWONotes': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .post(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber, dumpsodalog:'y' })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function deleteUmmDSTableLabor(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOLabor': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .delete(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function deleteUmmDSTableEquipment(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOEquipment': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .delete(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function deleteUmmDSTableMaterial(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOMaterial': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .delete(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function deleteUmmDSTablePhoto(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOStoredObject': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .delete(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function editUmmDSTableLabor(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOLabor': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .put(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function editUmmDSTableEquipment(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOEquipment': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .put(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

function editUmmDSTableMaterial(endpoint, woNumber, query, record, table) {
  let rtn = _()

  let dataset = {
    uMMds: {
      'uMMWOMaterial': [record]
    }
  }

  console.log('POST: ' + JSON.stringify(dataset) + ' to: ' + endpoint)
  
  request
  .put(Store.getServerUrl() + endpoint)
  .query({ useSystemCode: User.getSystemCode(), woNumber: woNumber })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}

export function postLaborRecord(woNumber, record) {
  return postUmmDSTableLabor('/umm/ummwolabor', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOLabor')
}

export function deleteLaborRecord(woNumber, record) {
  return deleteUmmDSTableLabor('/umm/ummwolabor', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOLabor')
}

export function editLaborRecord(woNumber, record) {
  return editUmmDSTableLabor('/umm/ummwolabor', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOLabor')
}

export function postEquipmentRecord(woNumber, record) {
  return postUmmDSTableEquipment('/umm/ummwoequipment', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOEquipment')
}

export function deleteEquipmentRecord(woNumber, record) {
  return deleteUmmDSTableEquipment('/umm/ummwoequipment', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOEquipment')
}

export function editEquipmentRecord(woNumber, record) {
  return editUmmDSTableEquipment('/umm/ummwoequipment', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOEquipment')
}

export function postMaterialRecord(woNumber, record) {
  return postUmmDSTableMaterial('/umm/ummwomaterial', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOMaterial')
}

export function deleteMaterialRecord(woNumber, record) {
  return deleteUmmDSTableMaterial('/umm/ummwomaterial', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOMaterial')
}

export function editMaterialRecord(woNumber, record) {
  return editUmmDSTableMaterial('/umm/ummwomaterial', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOMaterial')
}

export function postPhotoRecord(woNumber, record) {
  return postUmmDSTablePhoto('/umm/ummwostoredobject', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOStoredObject')
}

export function deletePhotoRecord(woNumber, record) {
  return deleteUmmDSTablePhoto('/umm/ummwostoredobject', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWOStoredObject')
}

export function postNotesRecord(woNumber, record) {
  return postUmmDSTableNotes('/umm/ummwonotes', woNumber, { useSystemCode: User.getSystemCode(), woNumber: woNumber }, record, 'uMMWONotes')
}

export function putWorkOrder(id, workOrder) {
  let rtn = _()

  let workOrderList = [workOrder]

  let dataset = {
    ummds: {
      uMMWorkOrder: workOrderList
    }
  }

  console.log('Work Order to PUT: ' + JSON.stringify(dataset))
  
  request
  .put(Store.getServerUrl() + '/umm/ummclosewo')
  .query({ useSystemCode: User.getSystemCode(), woNumber: id })
  .set('SODAUSER', User.getUsername())
  .set('SODAKEY', User.getPassword())
  .set('content-type', 'application/json')
  .send(dataset)
  .end((err, res) => {
    if (err || !res.ok) {
      let beefyError = new Error (JSON.stringify({
        originalError: err,
        body: res.body
      }))

//      console.error ('Error')
//      console.info (beefyError)

      rtn.write(beefyError)
    }
    rtn.end()  
  })

  return rtn.map( (data) => {
    if (data instanceof Error) {
      throw data
    } else {
      return data
    }
  })
}


// WEBPACK FOOTER //
// ./src/services/requests.js